import { defineComponent as _defineComponent } from 'vue'
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import IconDownload from '@/components/svg/download-circle.svg?inline';
import { ref } from 'vue';
import DeleteAccountPopup from '@/views/settings/components/popups/DeleteAccountPopup.vue';
import X from '@/components/svg-components/X.vue';
import useAgbState from '@/state/agbState';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXAgbPopup',
  setup(__props) {

const { tUserFallback: t } = useUser('self');

const {
  handleAcceptAgb,
  handleDownloadAgbAsPdf,
  handleRemindLater,
  isPastGracePeriod,
  waitingForServerResponse,
} = useAgbState();

const showChanges = ref(false);

const showDeleteAccountPopup = ref(false);


return { __sfc: true,t, handleAcceptAgb, handleDownloadAgbAsPdf, handleRemindLater, isPastGracePeriod, waitingForServerResponse, showChanges, showDeleteAccountPopup, BCXMarkdown, IconDownload, DeleteAccountPopup, X }
}

})